import indicatorTypes from './indicatorTypes.json';
import indicatorsComparison from './indicators-comparison.json';
import indicators from './indicators.json';

export default {
  indicatorTypes,
  indicators,
  indicatorsComparison,
};
